/**
 * The patterned rug in the apothecary's central aisle and its two fringes
 * (lifted from lantern-water's `world.js` `createShop`). The rug's artwork is
 * the scene's `rug` texture slot (a mirrored quarter) in the kit's `rug`
 * material. A once-built piece: origin at the room's centre on the floor. No
 * params. Its walking surface (0.03 m) is the scene's.
 */
import * as THREE from 'three';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'shop_rug',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { m } = ctx;
    const rug = ctx.mesh(root, ctx.plane, m.rug, 0, 0.07, 0.9, 4.8, 4.6, 1);
    rug.rotation.x = -Math.PI / 2;
    rug.receiveShadow = true;
    for (let x = -2.3; x < 2.4; x += 0.1) {
      ctx.box(root, x, 0.07, 3.25, 0.027, 0.015, 0.2, m.canvas);
      ctx.box(root, x, 0.07, -1.43, 0.027, 0.015, 0.2, m.canvas);
    }
    return { root };
  },
};
